import { render, staticRenderFns } from "./AlertQuotation.vue?vue&type=template&id=030868f6&scoped=true&"
import script from "./AlertQuotation.vue?vue&type=script&lang=js&"
export * from "./AlertQuotation.vue?vue&type=script&lang=js&"
import style0 from "./AlertQuotation.vue?vue&type=style&index=0&id=030868f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030868f6",
  null
  
)

export default component.exports